const HOME = "/";
// Placeholder origin: only used to resolve the path the way a browser would.
const SAME_SITE = "https://same-site.invalid";

/**
 * Turns the sign-in page's `?redirect=` value into a same-site path to land on.
 *
 * The value comes from the URL, so anyone can craft it. It is resolved with the URL
 * parser — the same one the browser navigates with, which strips tabs/newlines and
 * reads `/\host` as `//host` — and anything that resolves to another origin, or to the
 * sign-in page itself, falls back to home rather than turning sign-in into an open
 * redirect.
 */
export function safeRedirectPath(redirect: string | null): string {
  if (!redirect || !redirect.startsWith("/")) {
    return HOME;
  }
  const target = new URL(redirect, SAME_SITE);
  if (target.origin !== SAME_SITE || target.pathname === "/signin" || target.pathname.startsWith("/signin/")) {
    return HOME;
  }
  return target.pathname + target.search + target.hash;
}

/** Full page load (not router.push) so the whole app starts with the new auth state. */
export function goToPageAfterSignIn(redirect: string | null): void {
  window.location.href = safeRedirectPath(redirect);
}
